import { Component, ComponentInterface, h, Prop } from '@stencil/core';

import { uniWatermark } from '@uni/license';

@Component({ tag: 'uni-action-download' })
export class UniActionDownloadComponent implements ComponentInterface {

  @Prop({ reflect: true }) url!: string;

  @Prop({ reflect: true }) name: string = 'index.html';

  render(): any {
    return (
      <a href={this.url} download={this.name}>
        <slot />
      </a>
    );
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
